import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { PrivateRoute } from "@/components/auth/PrivateRoute";
import TrocarCausa from "@/pages/TrocarCausa";

export const Route = createFileRoute("/causas/trocar")({
  head: () => seoHead({
    title: "Trocar de causa | Shopping do Bem",
    description: "Escolha qual causa social receberá suas doações.",
    path: "/causas/trocar",
    noindex: true,
  }),
  component: () => (
    <PrivateRoute>
      <TrocarCausa />
    </PrivateRoute>
  ),
});
